import { useEffect, useState } from "react";

const DynamicFacilities = ({ heading: propHeading, cards: propCards }) => {
  const [expandedCards, setExpandedCards] = useState([]);
  const [displayedCards, setDisplayedCards] = useState([]);
  const [heading, setHeading] = useState(propHeading || "");

  useEffect(() => {
    if (Array.isArray(propCards) && propCards.length > 0) {
      setDisplayedCards(propCards);
      setHeading(propHeading || "Maintenance of Infrastructure & Facilities");
      setExpandedCards(Array(propCards.length).fill(false));
    } else {
      setDisplayedCards([]);
      setHeading(propHeading || "");
      setExpandedCards([]);
    }
  }, [propCards, propHeading]);

  const toggleReadMore = (index) => {
    setExpandedCards((prev) => {
      const updated = [...prev];
      updated.fill(false); // Close others to maintain layout stability
      updated[index] = !prev[index];
      return updated;
    });
  };

  // Logic to truncate description to 75 characters
  const getTruncatedText = (text) => {
    if (!text) return "";
    return text.length > 75 ? text.substring(0, 75) + "..." : text;
  };

  // Check if button should show (if text > 75 or there is read_more_content)
  const shouldShowReadMore = (card) => {
    const hasReadMoreHtml = card.read_more_content && card.read_more_content.replace(/<[^>]*>?/gm, '').trim().length > 0;
    const isTextLong = card.text && card.text.length > 75;
    return hasReadMoreHtml || isTextLong;
  };

  return (
    <>
      <div className="sec-title text-center">
        <h2>{heading}</h2>
      </div>

      <div className="facilities-section">
        <div className="row">
          {displayedCards.map((card, index) => (
            <div className="col-md-4 col-12 mb-5" key={index}>
              <div className="card card_fac shadow-sm border-0">
                <div className="card_fac_img_container" style={{ height: "200px", overflow: "hidden" }}>
                  <img 
                    src={`${process.env.REACT_APP_API_URL}/public${card.image}`} 
                    alt={card.alt || card.title} 
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>

                <div className="card-body card_fac_body d-flex flex-column" style={{ minHeight: "180px" }}>
                  <h5 className="card-title card_fac_title fw-bold">{card.title}</h5>

                  <div className="card-text card_fac_text-maintainence ">
                    {/* Show truncated text when collapsed, full text when expanded */}
                    <div className="main-description mb-2">
                      {expandedCards[index] ? card.text : getTruncatedText(card.text)}
                    </div>

                    {/* Show HTML content only when expanded */}
                    {expandedCards[index] && card.read_more_content && (
                      <div 
                        className="extra-content-html mt-2 animate-fade-in"
                        dangerouslySetInnerHTML={{ __html: card.read_more_content }}
                      />
                    )}
                  </div>

                  {/* Button stays at the bottom of the card body */}
                  {shouldShowReadMore(card) && (
                    <div className="text-center ">
                      <button
                        className="btn-about-maintainence"
                        onClick={() => toggleReadMore(index)}
                      >
                        {expandedCards[index] 
                          ? (card.read_less_text || "Read Less") 
                          : (card.read_more_text || "Read More")
                        }
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DynamicFacilities;